import { useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { AppText, GridContainer } from "src/style"
import ApiContext from 'src/provider/API/call-service'
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { UserType } from "src/model"

// FOR SSO SIGNIN
export const SigninV2: React.FC<any> = ({token}) => {
    const navigate = useNavigate()
    const { API } = useContext(ApiContext)
    const {clearStoredData} = useContext(AppInfoContext)

    useEffect(() => {
        handleValidateToken()
    }, [])

    async function handleValidateToken () {
        await clearStoredData()
        const response = await API.validateSSOToken(token)

        if (response) {
            navigate(response.userDetails?.userType === UserType.ADMIN ? '/admin/dashboard' : '/client/discover')
        }
    }

    return (
        <GridContainer height="100" hUnit="%">
            {/* <AppText textSize="3">SSO Token Received: {token}</AppText> */}
        </GridContainer>
    )
}
